import React, { useState } from 'react';
import ReceptionLayout from '../components/ReceptionLayout';
import ReceptionOnboardingBoard from '../modules/reception/ReceptionOnboardingBoard';
import ReceptionWalkinDesk from './ReceptionWalkinDesk';

/** Patient onboarding — appointments board first; walk-in desk on demand. */
export default function ReceptionPage() {
  const [mode, setMode] = useState('board');

  return (
    <ReceptionLayout
      pageTitle={mode === 'board' ? 'Patient Onboarding' : 'Walk-in check-in'}
      pageSubtitle={
        mode === 'board'
          ? 'Day-wise appointments, triage, payments and patient lookup'
          : 'Sectioned walk-in form — phone/email autofill, fee collection, then triage'
      }
    >
      <div data-testid="reception-page">
        {mode === 'board' ? (
          <ReceptionOnboardingBoard onWalkin={() => setMode('walkin')} />
        ) : (
          <ReceptionWalkinDesk onBack={() => setMode('board')} />
        )}
      </div>
    </ReceptionLayout>
  );
}
